export const MAX_MODAL_WIDTH = 1175;
export const MODAL_PADDING = 13;
export const HEADER_FONT_SIZE = 16;
export const ACTIONS_GRID_ITEM_MARGIN_TOP = 20;
